export const FOOTER_HEIGHT_ID = 'footer_id' as const
export const HEADER_HEIGHT_ID = 'header_id' as const
